import type { Nullish } from "@ca/types/util";

export function formatCurrency (value: Nullish<number>, withCents: boolean = false) {
	if (value === null || value === undefined) {
		return "--";
	}
	return new Intl.NumberFormat("en-US", {
		currency: "USD",
		style: "currency",
		minimumFractionDigits: withCents ? 2 : 0,
		maximumFractionDigits: withCents ? 2 : 0,
	}).format(value);
}